export default { jsonClient, httpClient, shopifyGraphql }

const ROOT = Shopify && Shopify.routes && Shopify.routes.root || '/'

const SHOPIFY_GRAPHQL_PATH = `${ROOT}api/2026-07/graphql.json`

function jsonClient(url, { body, ...params } = {}) {
  const headers = { 'Content-Type': 'application/json' }
  const reqParams = {
    ...params,
    headers: {
      ...headers,
      ...params.headers,
    },
  }

  if (body) reqParams.body = JSON.stringify(body)

  return window
    .fetch(url, reqParams)
    .then(async response => {
      if (response.ok) {
        return await response.json()
      } else {
        const errorMessage = await response.text()
        return Promise.reject(new Error(errorMessage))
      }
    })
}

function httpClient(url, params = {}) {
  return window
    .fetch(url, params)
    .then(async response => {
      if (response.ok) {
        return await response.text()
      } else {
        const errorMessage = await response.text()
        return Promise.reject(new Error(errorMessage, { cause: response.status }))
      }
    })
}

function shopifyGraphql(body) {
  return jsonClient(SHOPIFY_GRAPHQL_PATH, {
    method: 'POST',
    body,
  })
}
